import activity2021 from '@/assets/data/activities/2021';

export default {
  namespaced: true,
  state: () => ({
    list: activity2021.activities,
    totalHistoricValue: activity2021.totalHistoricValue
  }),
  getters: {
    list: state => {
      return state.list;
    },
    activity: state => id => {
      return state.list.find(p => p.id === Number(id));
    },
    min: state => {
      return Math.min(...state.list.map(a => a.value));
    },
    max: state => {
      return Math.max(...state.list.map(a => a.value));
    },
    total: state => {
      return state.list.reduce((acc, curr) => {
        return acc + curr.value;
      }, 0);
    },
    history: state => {
      return state.totalHistoricValue;
    }
  },
  actions: {},
  mutations: {}
};
